import styled from "styled-components";

export const IconeContainer = styled.div`
  padding: 0.75rem 1rem;
  background-color: #FFEAEE;
  border-radius: 0.5rem;
  svg {
    color: #E41324;
  }
`;

export const TextContainer = styled.div`
  text-align: center;
  max-height: 200px;
  overflow-y: auto;
  word-break: break-word;
  width: 100%;
`;

export const DigitosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
`;

export const DigitoButton = styled.button<{ $selecionado: boolean }>`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 0.375rem;
  border: 2px solid
    ${({ $selecionado, theme }) => ($selecionado ? theme.colors.project.main : "#ced4da")};
  background-color: ${({ $selecionado, theme }) =>
    $selecionado ? theme.colors.project.main : "#fff"};
  color: ${({ $selecionado }) => ($selecionado ? "#fff" : "#212529")};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.project.main};
    background-color: ${({ $selecionado, theme }) =>
      $selecionado ? theme.colors.project.dark : "#e7f0ff"};
    color: ${({ $selecionado, theme }) =>
      $selecionado ? "#fff" : theme.colors.project.main};
  }
`;

export const InfoContainer = styled.div`
  display: grid;
  place-items: center;
  gap: 1rem;
  padding: 1rem;
`;
